<app-loading *ngIf="loadingComponent"></app-loading>
<eess-bienvenido *ngIf="!loadingComponent"></eess-bienvenido>
<div class="row jc-c" *ngIf="cuestionarioPreguntas">
  <div class="col-12 col-md-10 col-xl-8">
    <div [formGroup]="form" class="pb-5 d-flex jc-c">
      <div class="bch-card pa-5">
        <div class="row">
          <div class="header col-12 col-md-10 mx-auto mt-4">
            <p class="c-brand-dark ta-c text--medium info">
              Para continuar, <strong>necesitas validar tu identidad</strong>. Por favor, contesta las siguientes preguntas.
            </p>
          </div>
        </div>
        <div class="body">
          <div class="row jc-c mt-5">
            <div class="col-12 col-md-10">
              <div class="pb-4" *ngFor="let question of this.preguntas.data.question; let i = index">
                <p class="c-brand-dark"><strong>{{ question.questionText }}</strong></p>
                <div class="bch-multichoice multichoice-vertical-list">
                  <mat-radio-group class="" [formControlName]="question.questionId">
                    <mat-radio-button class="opcion-pregunta-radio"
                      (change)="radioChange($event.value.answerId,i+1)"
                      *ngFor="let option of question.answerChoise" [value]="option">
                      {{ option.value }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-7 mx-auto px-0 px-md-4 bch-button-auto-size my-4">
            <bch-button [disabled]="form.invalid || load" [button]="buttonContinuar" (click)="sendPreguntas()"></bch-button>
          </div>
          <div class="d-flex jc-c">
            <div class="text--extra-small">
              <span>Protegido por reCAPTCHA - </span>
              <span>
                <a class="text--extra-small" [href]="privacidad">Privacidad - </a>
                <a class="text--extra-small" [href]="condiciones">Condiciones</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<fenix-mensaje *ngIf="anyTypeError"
            mensaje="{{mensaje}}"
            [mostrarAyuda]="false"
            titulo="{{titulo}}"
            textoBotonSecundario="REINTENTAR"
            (accionSecundaria)="reintentar()"
            tipo="warning">
</fenix-mensaje>
